import Logger from "logger/logger"
import {useEffect} from "react"
import {envQuery, envStore} from "store/system/environment/env.store"
import {useDebounce} from "utils/useDebounce"

function IsMobileService(caller: string) {

  const mobileWidth = 768

  const {debounce} = useDebounce()

  useEffect(() => {
    Logger('Service.IsMobile.init', caller)
    window.addEventListener('resize', isMobileWidth)
    isMobileWidth()
    return () => {
      Logger('Service.IsMobile.unloading', caller)
      window.removeEventListener('resize', isMobileWidth)
    }
  }, [])

  const isMobileWidth = () => (
    debounce(() => {
      const width = window.innerWidth
      const mobile = envQuery.getValue().isMobileWidth
      if (width <= mobileWidth && !mobile) {
        envStore.update(state => {
          state.isMobileWidth = true
        })
      }
      if (width > mobileWidth && (mobile || undefined === mobile)) {
        envStore.update(state => {
          state.isMobileWidth = false
        })
      }
    }, 500)
  )
}

export default IsMobileService
